import { Injectable } from '@angular/core';

@Injectable()
export class TimePickerService {
    constructor() {}

    public checkInput(event: KeyboardEvent, value: string): void {
        if (
            event.key === 'Backspace' ||
            event.key === 'Delete' ||
            event.key === 'Del' ||
            event.key === 'Tab' ||
            event.key === 'ArrowLeft' ||
            event.key === 'Left' ||
            event.key === 'ArrowRight' ||
            event.key === 'Right'
        ) {
            return;
        }

        const keyCode = event.key.charCodeAt(0);

        // keypress value can be only number or colon symbol
        if (keyCode < 47 || keyCode > 58) {
            event.preventDefault();
            return;
        }

        // colon symbol cant be placed as third character
        if (value.length > 3 && !value.includes(':')) {
            event.preventDefault();
            return;
        }

        if (value.includes(':')) {
            // replacing part of input
            if (keyCode !== 58 && value.length === 5) {
                return;
            }

            // value can have only one colon symbol
            if (keyCode === 58) {
                event.preventDefault();
                return;
            }
        }
    }

    public formatTime(hour: string, minute: string): string {
        return `${hour.toString().padStart(2, '0')}:${minute.toString().padEnd(2, '0')}`;
    }
}
